<template>
  <Modal
    v-model="_value"
    width="500"
    title="保险免费资格查询"
    @on-visible-change="visibleChange"
    cancel-text=""
    ok-text="关闭">
    <div style="margin-bottom: 10px;" v-for="(items,index) in information">{{index}}{{items}}
<!--      <div v-for="item in items">-->
<!--      {{item}}-->
<!--      </div>-->
    </div>
    <div style="margin-bottom: 10px;"><label :style="eligibility == true ?'color:blue;':'color:red;'">是否符合：{{eligibility == true ? '符合':'不符合'}}</label></div>
    <div style="margin-bottom: 10px;" v-for="items in msg"><label :style="eligibility == true ?'color:blue;':'color:red;'">不符合原因：{{items}}</label></div>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'inquireoperationmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
    },
    data() {
      return {
        clientInfo: {
          name: null,
          phoneNum: null,
          address: null,
          userId: null
        },
        result: [],
        information: [],
        eligibility: false,
        msg: [],
      }
    },
    methods: {
      ...mapActions([
        'VehicleInfoServ_InquireOperation'
      ]),
      visibleChange(val) {
        if (val) {
          this.information = []
          this.eligibility = false
          this.msg = []
          store.dispatch('VehicleInfoServ_InquireOperation',{
            params:{
              registrationNum : this._initValue
            }
          }).then(res=>{
            console.log(store.getters.get_VehicleInfo_InquireOperationResult)
            if (store.getters.get_VehicleInfo_InquireOperationResult) {
              this.result = store.getters.get_VehicleInfo_InquireOperationResult
              this.information = this.result[0]
              this.eligibility = this.result[1]
              this.msg = this.result[2]
            }
          }).catch(err=>{
            console.log(store.getters.get_VehicleInfo_InquireOperationResult)
            if (store.getters.get_VehicleInfo_InquireOperationResult) {
              this.result = store.getters.get_VehicleInfo_InquireOperationResult
              this.information = this.result.data[0]
              this.eligibility = this.result.data[1]
              this.msg = this.result.data[2]
            }
            console.log(err)
            this.$Message.error(err)
          })
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
